/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents, {
  BackButton,
} from "../../../../../../components/primaryComponents";
import {
  extractReadableDateOnly,
  formatCurrency,
} from "../../../../../../helpers";
// import { POExtra } from "../../../../../../components/secondaryComponents/PurchaseOrder";
import { Link, useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../../routes/pathContants";
import { WarningDialog } from "../../../../../../components/common";
import { useEditGoodsReceived } from "../EditGoodsReceived/useEditGoodsReceived";
import { useGoodsReceivedDetails } from "./useGoodsReceivedDetails";
import { GRItemsTable } from "../../../../../../components/secondaryComponents/GoodsReceived/GRItemsTable";
import { WaybillIcon } from "../../../../../../assets/svgIcons";
import { GRExtra } from "../../../../../../components/secondaryComponents/GoodsReceived";
import { useStoreListObject } from "../../../../../../hooks/useStoreListObject";

export const GoodsReceivedDetails = () => {
  const navigate = useNavigate();
  const { isLoading, GRDetails, GRItems } = useEditGoodsReceived({
    isEnabled: true,
  });
  const { isUpdatingStatus, views, setViews, handleApproveOrRejectGR } =
    useGoodsReceivedDetails();
  const { storeMap } = useStoreListObject();
  const currencyCode = storeMap?.[GRItems?.[0]?.store_id]?.currency_code;

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Good Received Details"
      description="View the details of goods received note"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <BackButton />
          </div>

          <secondaryComponents.LoaderHelper
            classNames={"mt-5"}
            isLoading={isLoading}
          >
            <div>
              <div className={`${globalStyles.pageHeaders} mb-3`}>
                <div>
                  <h3 className="font-weight-normal">
                    <span className="gray--text">GRN Number: </span>
                    {GRDetails?.gr_number || "N/A"}
                  </h3>
                </div>
                <div
                  className="d-flex flex-wrap ml-auto"
                  style={{ gap: "10px" }}
                >
                  {GRDetails?.status === "IN_REVIEW" ? (
                    <>
                      <secondaryComponents.NavigateWithPermission
                        permissionParentKey={"Inventory Management"}
                        permissionChildKey={
                          "can_approve_or_reject_goods_received"
                        }
                      >
                        <primaryComponents.Button
                          classNames={"btn btn--primary"}
                          style={{ width: "200px" }}
                          onClick={() => {
                            setViews((prev) => ({
                              ...prev,
                              isAcceptDialog: true,
                            }));
                          }}
                        >
                          Approve & Restock GRN
                        </primaryComponents.Button>

                        <primaryComponents.Button
                          classNames={"btn btn--outline-red "}
                          style={{ width: "140px" }}
                          onClick={() => {
                            setViews((prev) => ({
                              ...prev,
                              isRejectDialog: true,
                            }));
                          }}
                        >
                          Reject GRN
                        </primaryComponents.Button>
                      </secondaryComponents.NavigateWithPermission>
                    </>
                  ) : null}

                  {GRDetails?.status !== "ACCEPTED" ? (
                    <secondaryComponents.NavigateWithPermission
                      permissionParentKey={"Inventory Management"}
                      permissionChildKey={"can_create_or_update_goods_received"}
                    >
                      <primaryComponents.Button
                        classNames={"btn btn--outline"}
                        style={{ width: "140px" }}
                        onClick={() =>
                          navigate(
                            pathConstants.INVENTORY_GOODS_RECEIVED_EDIT({
                              id: GRDetails?.id,
                            }),
                          )
                        }
                      >
                        Update GRN
                      </primaryComponents.Button>
                    </secondaryComponents.NavigateWithPermission>
                  ) : null}

                  {GRDetails?.status === "ACCEPTED" ? (
                    <primaryComponents.Button
                      classNames={"btn btn--success"}
                      style={{ width: "140px" }}
                      onClick={() =>
                        navigate(
                          pathConstants.INVENTORY_BILLS_CREATE +
                            `?po_id=${GRDetails?.purchase_order?.id}&po_number=${GRDetails?.purchase_order?.po_number}`,
                        )
                      }
                    >
                      Generate Bill
                    </primaryComponents.Button>
                  ) : null}

                  <div className="ml-auto">
                    <GRExtra GRDetails={GRDetails} />
                  </div>
                </div>
              </div>

              <div className={globalStyles.gridDetailsView}>
                <div>
                  <p className="dark--text">Status</p>
                  <p
                    className={`${globalStyles[GRDetails?.status === "IN_REVIEW" ? "statusBlock--pending" : GRDetails?.status === "ACCEPTED" ? "statusBlock--success" : GRDetails?.status === "REJECTED" ? "statusBlock--failed" : "statusBlock"]}`}
                  >
                    {GRDetails?.status?.replace("_", " ") || "N/A"}
                  </p>
                </div>

                <div>
                  <p className="dark--text">GRN Issue Date</p>
                  <p className="small-text-size">
                    {GRDetails?.gr_date
                      ? extractReadableDateOnly(GRDetails?.gr_date)
                      : "N/A"}
                  </p>
                </div>
                <div>
                  <p className="dark--text">Supplier</p>
                  <Link
                    to={pathConstants.INVENTORY_SUPPLIERS_DETAILS({
                      id: GRDetails?.supplier?.id,
                    })}
                    className="purple--text"
                  >
                    {GRDetails?.supplier?.name || "N/A"}
                  </Link>
                </div>
                <div>
                  <p className="dark--text">Amount</p>
                  <p className="small-text-size">
                    {formatCurrency({
                      value: GRDetails?.total_item_amount,
                      currencyCode: currencyCode,
                    })}
                  </p>
                </div>
                <div>
                  <p className="dark--text">PO Number</p>
                  <Link
                    to={pathConstants.INVENTORY_PURCHASE_ORDER_DETAILS({
                      id: GRDetails?.purchase_order?.id,
                    })}
                    className="small-text-size purple--text cursor-pointer"
                  >
                    {GRDetails?.purchase_order?.po_number || "N/A"}
                  </Link>
                </div>
                <div>
                  <p className="dark--text">Store</p>
                  <p className="small-text-size">
                    {GRDetails?.stores?.map((store) => store?.name)?.join(", ")}
                  </p>
                </div>
                <div>
                  <p className="dark--text">Total Goods Received </p>
                  <p className="small-text-size">
                    {GRDetails?.initiated_by?.first_name || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="dark--text">Created by</p>
                  <p className="small-text-size">
                    {GRDetails?.initiated_by?.first_name || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="dark--text">Approved By</p>
                  <p className="small-text-size">
                    {GRDetails?.approved_by?.first_name || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="dark--text">Rejected By</p>
                  <p className="small-text-size">
                    {GRDetails?.rejected_by?.first_name || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="dark--text">Waybill No</p>
                  <p className="small-text-size">
                    {GRDetails?.waybill_no || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="dark--text">Driver&apos;s Name</p>
                  <p className="small-text-size">
                    {GRDetails?.waybill_driver_name || "N/A"}
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h5>Order Items</h5>

              <div
                className={`${globalStyles.cardWithBackground} white`}
                style={{ gap: "30px" }}
              >
                <GRItemsTable GRItems={GRItems} GRDetails={GRDetails} />

                <div>
                  <h4 className="font-weight-normal mb-3">Price Summary</h4>
                  <div className="d-flex justify-content-between">
                    <p>Total</p>
                    <h5>
                      {formatCurrency({
                        value: GRDetails?.total_item_amount,
                        currencyCode: currencyCode,
                      })}
                    </h5>
                  </div>
                </div>

                <div>
                  <h4 className="font-weight-normal mb-3">
                    Additional Details
                  </h4>
                  <div
                    className={"d-flex flex-column flex-md-row"}
                    style={{ gap: "15px" }}
                  >
                    <div
                      className={`d-flex flex-column w-100 ${globalStyles.cardWithBorder}`}
                      style={{ gap: "25px" }}
                    >
                      <div>
                        <p className="small-text-size">Waybill No</p>
                        <h5 className="font-weight-semibold">
                          {GRDetails?.waybill_no || "N/A"}
                        </h5>
                      </div>
                      <div>
                        <p className="small-text-size">Driver&apos;s Name</p>
                        <h5 className="font-weight-semibold">
                          {GRDetails?.waybill_driver_name || "N/A"}
                        </h5>
                      </div>
                      <div>
                        <p className="small-text-size">
                          Driver&apos;s Phone Number
                        </p>
                        <h5 className="font-weight-semibold">
                          {GRDetails?.waybill_driver_phone_code || ""}{" "}
                          {GRDetails?.waybill_driver_phone_number || "N/A"}
                        </h5>
                      </div>

                      <div>
                        <p>Comments or Special Instruction </p>
                        <h5 className="font-weight-semibold">
                          {GRDetails?.notes || "N/A"}
                        </h5>
                      </div>
                    </div>

                    <div className={`w-100 ${globalStyles.cardWithBorder}`}>
                      <p>Waybill Proof </p>
                      {GRDetails?.waybill_url ? (
                        <primaryComponents.Button
                          classNames={"btn btn--outline"}
                          onClick={() => window.open(GRDetails?.waybill_url)}
                          style={{ width: "200px", height: "40px" }}
                        >
                          <WaybillIcon className="mr-2" />
                          View Waybill
                        </primaryComponents.Button>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </secondaryComponents.LoaderHelper>

          {/* Approve Modal */}
          <secondaryComponents.Modal
            isActive={views?.isAcceptDialog}
            closeModal={() =>
              setViews((prev) => ({ ...prev, isAcceptDialog: false }))
            }
            width={500}
          >
            <WarningDialog
              title={`Approve GRN: ${GRDetails?.gr_number}`}
              btnClassNames="btn--primary"
              closeModal={() =>
                setViews((prev) => ({ ...prev, isAcceptDialog: false }))
              }
              handler={() => handleApproveOrRejectGR(GRDetails?.id, "ACCEPTED")}
              isLoading={isUpdatingStatus}
            >
              <p>
                Supplier:{" "}
                <span className="dark--text">{GRDetails?.supplier?.name}</span>
              </p>
              <p>
                GR Date:{" "}
                <span className="dark--text">
                  {GRDetails?.gr_date
                    ? extractReadableDateOnly(GRDetails?.gr_date)
                    : "N/A"}
                </span>
              </p>
            </WarningDialog>
          </secondaryComponents.Modal>

          {/* Reject Modal */}
          <secondaryComponents.Modal
            isActive={views?.isRejectDialog}
            closeModal={() =>
              setViews((prev) => ({ ...prev, isRejectDialog: false }))
            }
            width={500}
          >
            <WarningDialog
              title={`Reject GRN: ${GRDetails?.gr_number}`}
              closeModal={() =>
                setViews((prev) => ({ ...prev, isRejectDialog: false }))
              }
              handler={() => handleApproveOrRejectGR(GRDetails?.id, "REJECTED")}
              isLoading={isUpdatingStatus}
            >
              <p>
                Supplier:{" "}
                <span className="dark--text">{GRDetails?.supplier?.name}</span>
              </p>
              <p>
                GR Date:{" "}
                <span className="dark--text">
                  {GRDetails?.gr_date
                    ? extractReadableDateOnly(GRDetails?.gr_date)
                    : "N/A"}
                </span>
              </p>
            </WarningDialog>
          </secondaryComponents.Modal>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
